import React, {Component} from 'react'
import {Button} from 'reactstrap';
import {NavLink} from 'react-router-dom';

export default class Location extends Component {

    render() {
        const location = this.props.location;
        return (
            <tr>
                <td>
                    <NavLink to={`/customer/${location.id}`}>
                    {location.name}
                    </NavLink>
                </td>
                <td>
                    {location.zip}
                </td>
                <td>
                    {location.street}
                </td>
                <td>
                    <Button color='danger'>
                        <i className='fa fa-trash'> </i>
                    </Button>
                </td>
            </tr>
        )
    }

}